import { NAMESPACE } from 'www/vue_components/common/Club/components/core/ClubCardGetting/constants'

const el = document.querySelector(NAMESPACE.mountSelector)

if (el && !window.USER.club.isInClub) {
  (async () => {
    const { default: Vue } = await import(/* webpackMode: "eager" */'www/vue_components')
    const { default: vuetify } = await import(/* webpackMode: "eager" */'www/modules/vuetify-plugin')
    const { default: ClubCardGetting } = await import(/* webpackMode: "eager" */'www/vue_components/common/Club/components/core/ClubCardGetting/ClubCardGetting.vue')

    new Vue({
      el,
      vuetify,
      render: h => h(ClubCardGetting),
    })
  })()
}
